import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

import Merchants from '@/components/Merchants';
import MainHomeContent from '@/components/merchants/MainHomeContent';
import MainCityView from '@/components/merchants/MainCityView';
import MainMerchantView from '@/components/merchants/MainMerchantView';

import lang from '../lang/lang';

Vue.use(Router);
Vue.use(Meta);

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  }

  const position = { x: 0, y: 0 };

  if (to.matched.some(m => m.meta.scrollToTop)) {
    position.x = 0
    position.y = 0
  }

  if (to.hash) {
    position.selector = to.hash
  }

  if (to.hash === '#promotions') {
    position.y = 490;
  }

  return position

}

// short language url
// const shortLocale = lang.locale.substr(lang.locale.length - 2).toLowerCase();

var CloudflareCountryDetection = (function(code) {
  switch(code) {
    case 'es-CL':
      return 'chile';
    case 'es-MX':
      return 'mexico';
    case 'es-AR':
      return 'argentina';
    case 'es-ES':
      return 'espana';
    case 'en-US':
      return 'eeuu';
    case 'pt-BR':
      return 'brasil';
    default:
      return 'chile'; // default
  }
})(lang.locale);

export default new Router({
  mode: 'history',
  base: __dirname,
  scrollBehavior,
  routes: [
    {
      path: '/',
      redirect: `/${CloudflareCountryDetection}`,
      // redirect: headerMap.country,
      meta: { lang: lang.locale }
    },
    // main
    // {
    //   path: '/',
    //   name: 'main',
    //   component: Merchants,
    //   meta: { scrollToTop: true, lang: lang.locale },
    //   children: [
    //     {
    //       path: '',
    //       component: MainHomeContent,
    //     },
    //   ],
    // },
    {
      path: '/:country',
      name: 'country',
      component: Merchants,
      meta: { scrollToTop: true, lang: lang.locale },
      children: [
        {
          path: '',
          component: MainHomeContent,
        },
      ],
    },
    {
      path: '/:country/:city',
      name: 'country_city',
      component: Merchants,
      meta: { scrollToTop: true, lang: lang.locale },
      children: [
        {
          path: '',
          component: MainCityView,
        },
      ],
    },
    {
      path: '/:country/:city/:merchant',
      name: 'country_city_merchant',
      component: Merchants,
      meta: { scrollToTop: true, lang: lang.locale },
      children: [
        {
          path: '',
          component: MainMerchantView,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js